module.exports = {
        srcSet: "/_next/static/images/prague-640.72811a99.webp"+" 640w"+","+"/_next/static/images/prague-700.e587afc4.webp"+" 700w",
        images: [{path: "/_next/static/images/prague-640.72811a99.webp",width: 640,height: 640},{path: "/_next/static/images/prague-700.e587afc4.webp",width: 700,height: 700}],
        src: "/_next/static/images/prague-700.e587afc4.webp",
        toString: function(){return "/_next/static/images/prague-700.e587afc4.webp"},
        
        width: 700,
        height: 700
      }